module.exports = __webpack_public_path__ + "img/logo.99ba0864.svg";